import { CallIconWithStatus } from './CallIcon.styles';
import { callIconStatusCircles } from './CallIconStatusCircle';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallIcon = ({
  title,
  status,
  shouldShowActiveCallState = false,
  statusSeleniumTestId,
  color: propColor,
  width = '14px',
  height = '14px',
  display = 'flex'
}) => {
  const theme = useTheme();
  const color = propColor !== null && propColor !== void 0 ? propColor : theme.color['global-shell-icon-nav-item-default'];
  return /*#__PURE__*/_jsxs(CallIconWithStatus, {
    width: width,
    height: height,
    children: [/*#__PURE__*/_jsxs("svg", {
      viewBox: "0 0 32 32",
      width: width,
      height: height,
      display: display,
      fill: color,
      children: [/*#__PURE__*/_jsx("title", {
        children: title
      }), /*#__PURE__*/_jsx("path", {
        d: "m22.63,29.99c-1.01,0-2.09-.16-3.24-.48-1.11-.31-2.13-.69-3.11-1.16-.03-.02-.06-.03-.1-.05-2.74-1.36-5.18-3.13-7.27-5.26-2.17-2.13-3.94-4.59-5.28-7.31l-.08-.19c-.19-.37-.37-.8-.58-1.37-1.55-4.11-1.23-7.68.87-9.78l1.53-1.53c1.17-1.16,3.19-1.16,4.36,0l4.07,4.07c.58.58.9,1.36.9,2.19s-.32,1.6-.91,2.19l-2.97,2.97c-.1.1-.15.23-.15.36s.05.26.15.36l6.12,6.12c.19.19.53.19.72,0l2.97-2.97c1.17-1.17,3.21-1.17,4.37,0l4.09,4.08c.58.58.91,1.36.91,2.19s-.32,1.6-.9,2.19l-1.54,1.53c-1.23,1.23-2.92,1.86-4.92,1.86Zm-5.36-3.24c.83.39,1.67.7,2.62.96,2.74.77,4.99.45,6.34-.9l1.54-1.53c.23-.23.36-.54.36-.86s-.13-.63-.36-.87l-4.09-4.08c-.46-.46-1.27-.46-1.73,0l-2.97,2.97c-.9.89-2.46.9-3.36,0l-6.12-6.12c-.45-.45-.7-1.04-.7-1.68s.25-1.23.7-1.68l2.97-2.97c.23-.23.36-.54.36-.87s-.13-.64-.36-.87l-4.07-4.07c-.46-.45-1.26-.45-1.72,0l-1.52,1.52h0c-1.56,1.56-1.72,4.4-.44,7.8.19.5.35.88.53,1.23l.09.19c1.23,2.5,2.88,4.79,4.91,6.77,2,2.04,4.34,3.71,6.97,5,.02.01.05.02.07.04ZM4.5,5.06h0,0Z"
      })]
    }), status && callIconStatusCircles[status]({
      shouldShowActiveCallState,
      title,
      dataSeleniumTest: statusSeleniumTestId,
      color
    })]
  });
};